<template>
  <div class="forgot-password-container login-container">
    <div class="limiter">
      <div class="container-login100">
        <div class="wrap-login100">
          <div class="login100-pic" data-tilt>
            <img :src="require('@/assets/img-01.png')" alt="IMG" />
          </div>

          <el-form>
            <span class="login100-form-title"> We almost finished </span>
            <el-form-item prop="email" label="">
              <span class="txt1">Check your email, We have sent you the necessary instructions to recover your password.</span>
              <div class="text-center p-t-12">
                <el-button type="text" @click="$router.push('/login')">
                  Go back to the sign in page</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>


<style lang="scss">
@import "~@/styles/login.scss";
.forgot-password-container{
  .txt1 {
    font-family: Poppins-Regular;
    font-size: 14px;
    line-height: 1.5;
    color: #606266;
  }
  .el-form-item__content {
    line-height: 30px;
    position: relative;
    font-size: 14px;
}
}
</style>